import { render, staticRenderFns } from "./VueGoogleAutocomplete.vue?vue&type=template&id=bf73bf4a"
import script from "./VueGoogleAutocomplete.vue?vue&type=script&lang=js"
export * from "./VueGoogleAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports